import React, { useEffect, useState } from 'react';
import axios from 'axios';
import HeaderDash from '../HeaderDashNew';
import Footer from '../Footer';
import './Notifications.css';
import ENDPOINTS from '../../../endpoints';
import { useUserAuth } from '../../../context/UserAuthContext';

interface Notification {
  _id: string;
  title: string;
  message: string;
  is_read: boolean;
  created_at: string;
}

const Notifications: React.FC = () => {
  const { userData } = useUserAuth();
  const [notifications, setNotifications] = useState<Notification[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [itemsPerPage] = useState<number>(10);

  useEffect(() => {
    fetchNotifications();
  }, [userData]);

  const fetchNotifications = async () => {
    try {
      const token = localStorage.getItem('token');

      const response = await axios.get(
        ENDPOINTS.fetchNotifications,
        {
          params: {
            user_id: userData?.id,
          },
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
          }
        }
      );
      console.log('Fetched notifications:', response.data.notifications);
      setNotifications(response.data.notifications);
    } catch (error) {
      console.error('Error fetching notifications:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return <div className="loading">Loading notifications...</div>;
  }

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentNotifications = notifications.slice(indexOfFirstItem, indexOfLastItem);
  const totalPages = Math.ceil(notifications.length / itemsPerPage);

  return (
    <div className="notifications-page">
      <HeaderDash />
      <div className="main-content">
        <h1>Your Notifications</h1>

        <div className="notification-table-wrapper">
        <table className="notification-table">
          <thead>
            <tr>
              <th>Title</th>
              <th>Message</th>
              <th>Date</th>
            </tr>
          </thead>
          <tbody>
            {currentNotifications.map((notification) => (
              <tr key={notification._id}>
                <td>{notification.title}</td>
                <td>{notification.message}</td>
                <td>
                  {new Date(notification.created_at).toLocaleDateString()} <br />
                  {new Date(notification.created_at).toLocaleTimeString()}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        </div>
        <div className="pagination">
          <button
            disabled={currentPage === 1}
            onClick={() => setCurrentPage(prev => prev - 1)}
          >
            Prev
          </button>
          <span>Page {currentPage} of {totalPages}</span>
          <button
            disabled={currentPage === totalPages}
            onClick={() => setCurrentPage(prev => prev + 1)}
          >
            Next
          </button>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default Notifications;